<template>
	<div class="dankal-image-upload">
		<p v-for="(item,index) in list" :key="index">
			<audio :id="'myVideo'+currentIndex" :src="item.indexOf('http')!=-1?item:imgDomain + item" controls="controls"
				ref="videoPlayer">
				您的浏览器不支持 audio 标签。
			</audio>
			<img class="close" src="@/assets/images/ic_delete.png" @click="onDeleted(index)" v-if="!disabled">
		</p>
		<div class="add-box flex flex-c" @click="onSelected" v-if="list.length < limit && !disabled">
			<i class="el-icon-video-camera" style="font-size: 52px;color: #999;"></i>
			<div class="cla">点击上传音频文件</div>
			<el-button type="primary" style="width: 150px;margin-top: 10px;height: 35px;"
				class="flex flex-c">上传音频</el-button>
		</div>
		<input ref="input" type="file" id="file" accept="audio/*" style="display:none;" @change="onFileChanged">
	</div>
</template>

<script>
	import ImageCompressor from "image-compressor.js";
	import {
		uploadImgFile,
		qiniuInfo
	} from "@/api/common";
	import {
		imgDomain
	} from '@/configs/env';
	import {
		mapState,
		mapActions
	} from "vuex";

	export default {
		name: "DankalImageUpload",
		data() {
			return {
				imgDomain,
				list: [],
				toast: "",
				file_type: this.type //图片还是视频
			};
		},
		created() {},
		props: {
			value: {
				type: [Array, String],
				required: true
			},
			currentIndex: {
				type: Number,
				default: 0
			},
			limit: {
				type: Number,
				default: 3
			},
			quatity: {
				type: Number,
				default: 0.6
			},
			type: {
				type: String,
				default: "image"
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},

		computed: {
			...mapState(["bucket_domain_token"])
		},
		mounted() {
			if (this.value) {
				this.list.push(this.value)
			}
		},
		// watch:{
		// 	value(newVal,oldVal){
		// 		this.list.push(newVal)
		// 		console.log(this.list,"视频文件")
		// 	},
		// },
		methods: {
			...mapActions(["getUrlAndTokenOfImageUpload"]),
			onSelected() {
				const {
					limit,
					list
				} = this;

				if (limit && list.length >= limit) {
					this.$message(`只能上传${limit}张图片`);
					return;
				}
				this.$refs.input.click();
			},

			onDeleted(index) {
				// Array.prototype.splice(this.list, index, 1);
				this.list.splice(index, 1);
				//不置空 删除之后上传同张图片无法出发change事件
				this.$refs.input.value = "";
				this.$emit("input", this.list, this.currentIndex);
			},

			onFileChanged(event) {
				const file = event.target.files[0];
				const {
					type
				} = file;
				this.getUrlAndTokenOfImageUpload();
				if (!file) return;
				if (type.indexOf("image") !== -1) {
					this.file_type = "image";
				}
				if (type.indexOf("video") !== -1) {
					this.file_type = "video";
				}
				this.upload(file);
			},
			async upload(file) {
				let that = this
				const formData = new FormData();
				formData.append('file', file);
				var url = "/common/Upload";
				const res = await uploadImgFile(url, formData).catch(() => {});
				if (res.status === 200) {
					that.list.push(res.data.result);
					that.$nextTick(() => {
						const audioElement = document.getElementById('myVideo'+that.currentIndex); // 你的audio元素

						audioElement.addEventListener('loadedmetadata', function() {
							// 确保在此事件内获取时长
							if (audioElement.duration !== Infinity && !isNaN(audioElement.duration)) {
								const duration = audioElement.duration;
								that.$emit('input', that.list, that.currentIndex,
								parseFloat(duration).toFixed(2));
							} else {}
						});
						// 如果loadedmetadata事件不触发，可以尝试监听onCanplay，但注意平台差异
						audioElement.addEventListener('canplay', function() {
							// 此处获取可能仍为NaN，尤其是在真机或iOS上[1](@ref)
						});
					})
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.dankal-image-upload {
		display: flex;
		flex-wrap: wrap;

		p {
			position: relative;
			float: left;

			.upload_img {
				width: 150px;
				height: 150px;
				object-fit: cover;
			}

			.close {
				width: 20px;
				height: 20px;
				position: absolute;
				right: -50px;
				cursor: pointer;
			}
		}

		.add-box {
			display: flex;
			flex-direction: column;
			margin-top: 20px;
			border-width: 0px;
			width: 650px;
			height: 268px;
			background: inherit;
			background-color: rgba(242, 242, 242, 1);
			border-radius: 12px;

			.cla {
				font-size: 16px;
				color: #000;
				line-height: 30px;
			}
		}
	}
</style>